import React, { useEffect, useState } from "react";
import { useAuth } from "../Context";
import "../../App.css";
import { Table, Button, Input, message, Typography, Space, Select } from "antd";
import { auth } from "../../firebase";
import auditedServices from "../../servicios/vehiculos/serviciosAudit";
const { obtenerVehiculosPorSucursal, editarVehiculo } = auditedServices;
import { getVehiculoColumns } from "./utils/columnsVehiculos.jsx";
import FiltroSucursal from "../sucursales/FiltroSucursal";
import { ModalVehiculo } from "./ModalVehiculo";

const { Title } = Typography;
const { Option } = Select;

const BuscarVehiculo = () => {
  const { sucursal: sucursalContext, role, isAdmin } = useAuth();
  const [searchText, setSearchText] = useState("");
  const [sucursal, setSucursal] = useState(sucursalContext || "");
  const [loading, setLoading] = useState(false);
  const [vehiculos, setVehiculos] = useState([]);
  const [modalVisible, setModalVisible] = useState(false);
  const [vehiculoActual, setVehiculoActual] = useState(null);
  const [modoEdicion, setModoEdicion] = useState(false);
  const [modalLoading, setModalLoading] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);

  // Columnas reutilizables
  const columns = getVehiculoColumns(
    (vehiculo) => {
      setVehiculoActual(vehiculo);
      setModoEdicion(true);
      setModalVisible(true);
    },
    (vehiculo) => {
      setVehiculoActual(vehiculo);
      setModoEdicion(false);
      setModalVisible(true);
    }
  );

  const handleEdit = (record) => {
    // onEdit(record.id);
    message.success("Empleado actualizado exitosamente: ");
  };

  const handleDisable = async (record, status) => {
  // ...
    try {
      const body = {};
      body["status"] = status ? "Activo" : "Inactivo";
      body["uid"] = record.id;
      const tokenValid = await auth.currentUser.getIdToken(true);
      // const response = await disableUser(tokenValid, body);
      const response = true;
      if (response) message.info("Empleado desactivado exitosamente.");
      else message.warning("No se pudo desactivar el usuario");
    } catch (error) {
      console.error("Error al deshabilitar el usuario con UID:", error);
    }
  };

  const handleMenuClick = (action, record) => {
    if (action === "edit") {
      handleEdit(record);
    } else if (action === "disable") {
      handleDisable(record, false);
    } else if (action === "active") {
      handleDisable(record, true);
    }
  };

  const menu = (record) => (
    <Menu onClick={(e) => handleMenuClick(e.key, record)}>
      {/* <Menu.Item key="edit" icon={<EditOutlined />}>
          Editar
        </Menu.Item> */}
      {record.estatus === "Activo" ? (
        <>
          <Menu.Item key="disable" icon={<EyeOutlined />}>
            Deshabilitar
          </Menu.Item>
        </>
      ) : (
        <>
          <Menu.Item key="active" icon={<EyeOutlined />}>
            Activar
          </Menu.Item>
        </>
      )}
    </Menu>
  );

  const filteredData = vehiculos.filter((item) =>
    Object.values(item)
      .join(" ")
      .toLowerCase()
      .includes(searchText.toLowerCase())
  );

  const conditionalRowStyles = [
    {
      when: (row) => true,
      style: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      },
    },
  ];

  const handleRowSelected = React.useCallback((state) => {
    setSelectedRows(state.selectedRows);
  }, []);

  const handleDeleteRows = () => {
    if (
      window.confirm(`¿Estas seguro?:\r ${selectedRows.map((r) => r.name)}?`)
    ) {
      setToggleCleared(!toggleCleared);
      setSelectedRows([]);
    }
  };

  function convertArrayOfObjectsToCSV(rows) {
    const header = datalayer[0];
    delete header.id;

    let result;

    const columnDelimiter = ",";
    const lineDelimiter = "\n";
    const keys = Object.keys(header);

    result = "";
    result += keys.join(columnDelimiter);
    result += lineDelimiter;

    rows.forEach((item) => {
      let ctr = 0;
      keys.forEach((key) => {
        if (ctr > 0) result += columnDelimiter;

        result += item[key];

        ctr++;
      });
      result += lineDelimiter;
    });

    return result;
  }

  function downloadCSV(array) {
    if (array.length === 0) {
      message.info("Debe seleccionar los empleados que desea exportar");
      return;
    }
    array = array.map((row) => {
      const dataWithoutId = { ...row };
      delete dataWithoutId.id;
      return dataWithoutId;
    });

    const link = document.createElement("a");
    let csv = convertArrayOfObjectsToCSV(array);
    if (csv == null) return;

    const filename = "Empleados.csv";

    if (!csv.match(/^data:text\/csv/i)) {
      csv = `data:text/csv;charset=utf-8,${csv}`;
    }

    link.setAttribute("href", encodeURI(csv));
    link.setAttribute("download", filename);
    link.click();
  }

  const Export = ({ selectedRows, onExport }) => (
    <Button
      style={{ zIndex: 100, position: "absolute" }}
      onClick={() => onExport(selectedRows)}
    >
      Export
    </Button>
  );

  const actionsMemo = React.useMemo(
    () => (
      <Export
        selectedRows={selectedRows}
        onExport={(selectedRows) => downloadCSV(selectedRows)}
      />
    ),
    [selectedRows]
  );

  useEffect(() => {
    if (!sucursal) return;
    const loadVehiculos = async () => {
      setLoading(true);
      try {
        const token = await auth.currentUser.getIdToken(true);
        const res = await obtenerVehiculosPorSucursal(token, sucursal);
        if (res.success) setVehiculos(res.vehiculos);
        else setVehiculos([]);
      } catch (e) {
        setVehiculos([]);
        message.error("Error al cargar vehículos");
      }
      setLoading(false);
    };
    loadVehiculos();
  }, [sucursal, sucursalContext]);

  return (
    <div style={{ maxWidth: 1200, margin: 'auto', padding: 24 }}>
      <Title level={3} style={{ textAlign: "center", marginBottom: 24 }}>
        Información de Vehículos
      </Title>
      <Space style={{ marginBottom: 16, width: '100%', justifyContent: 'flex-start', display: 'flex', gap: 16 }}>
  <FiltroSucursal onSucursalChange={setSucursal} value={sucursal} />
        <Input.Search
          placeholder="Buscar vehículo..."
          value={searchText}
          onChange={e => setSearchText(e.target.value)}
          style={{ maxWidth: 300 }}
        />
      </Space>
      <Table
        columns={columns}
        dataSource={filteredData}
        loading={loading}
        rowKey="placa"
        pagination={{ pageSize: 10 }}
      />
      <ModalVehiculo
        visible={modalVisible}
        onCancel={() => setModalVisible(false)}
        onOk={handleModalOk}
        vehiculo={vehiculoActual}
        modoEdicion={modoEdicion}
        loading={modalLoading}
      />
    </div>
  );

  // ---
  // Definir handleModalOk fuera del return para evitar errores de sintaxis
  function handleModalOk(values) {
    setModalLoading(true);
    (async () => {
      try {
        const token = await auth.currentUser.getIdToken(true);
        const res = await editarVehiculo(token, { ...vehiculoActual, ...values, sucursal });
        if (res.success) {
          message.success('Vehículo actualizado correctamente');
          setModalVisible(false);
          // Recargar lista
          const res2 = await obtenerVehiculosPorSucursal(token, sucursal);
          if (res2.success) setVehiculos(res2.vehiculos);
        } else {
          message.error(res.msg || 'Error al actualizar vehículo');
        }
      } catch (e) {
        message.error('Error al actualizar vehículo');
      }
      setModalLoading(false);
    })();
  }
}

export default BuscarVehiculo;
